var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: _vm.computedClass },
    [
      _vm.icon
        ? _c("JadeIcon", {
            attrs: { use: _vm.icon, size: "small", color: "current-color" },
          })
        : _vm._e(),
      _c(
        "jade-text",
        {
          attrs: {
            variant: "text-small",
            weight: "semibold",
            color: "current-color",
          },
        },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }